import React from 'react'
import { Link } from "react-router-dom";

const Footer = () => (
    <div className="footer">
        <div className="container">
            <div className="contact-logo">
                <img src={require("../../static/images/00_global/logo.png")} alt="logo"/>
            </div>
            <div className="contact-line">
                <Link to="">
                    <img src={require("../../static/images/00_global/line.png")} alt="line"/>
                    <p>apscooling</p>
                </Link>
            </div>
            <div className="contact-call">
                <img src={require("../../static/images/00_global/call.png")} alt="call"/>
                <div className="call-number">
                    <p>062-426-9978</p>
                    <p>086-336-2566</p>
                </div>
            </div>
        </div>
    </div>
)

export { Footer }